import { Component, OnInit } from '@angular/core';
import { AppService }  from '../../services/app.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit {

  constructor(
    public appService: AppService,
		private router: Router
  ) { }

  ngOnInit(): void {
		this.appService.setDefaultAuthor();
	  this.appService.navActive();
		
		this.appService.setPageTitle('Debug');
		this.appService.setPageDescription('');
  }

  addToast () {
    this.appService.addToast('sso-toast', 'Login', 'login');
    // this.appService.addToast('check-toast', 'Nakijken', 'check');
    // this.appService.addToast('text-toast', 'Tekst', 'text');
    this.router.navigate(['/index']);
  }
}